import publicRequest from '@/utils/publicRequest'

// ========== 公共接口（无需登录，使用 publicRequest 不带 Authorization 头） ==========

// 获取系统配置（公共，用于维护模式等前端状态）
export function getPublicSystemConfig() {
  return publicRequest({ url: '/ftx/content/config/public', method: 'get' })
}

// 获取公告列表（公共）
export function getPublicAnnouncements(params) {
  return publicRequest({ url: '/ftx/content/announcements', method: 'get', params })
}

// 获取公告详情（公共）
export function getPublicAnnouncementDetail(id) {
  return publicRequest({ url: `/ftx/content/announcements/${id}`, method: 'get' })
}

// 获取平台介绍（公共）
export function getPublicPlatformIntro() {
  return publicRequest({ url: '/ftx/content/intro', method: 'get' })
}

// 获取新手引导（公共）
export function getPublicGuideConfig() {
  return publicRequest({ url: '/ftx/content/guide', method: 'get' })
}

// 获取金刚区入口列表（公共，用于首页金刚区动态渲染）
export function getPublicShortcuts() {
  return publicRequest({ url: '/ftx/content/shortcuts', method: 'get' })
}

// ========== 需登录接口 ==========

import request from '@/utils/request'

// 获取公告列表
export function getNotices(params) {
  return request({ url: '/ftx/announcement/list', method: 'get', params })
}

// 获取公告详情
export function getNoticeDetail(id) {
  return request({ url: `/ftx/announcement/${id}`, method: 'get' })
}

// 获取邀请信息（从用户profile获取invite_uid等）
export function getInviteInfo() {
  return request({ url: '/ftx/user-center/profile', method: 'get' })
}

// 获取返佣记录（用户查询自己的返佣）
export function getRebateRecords(params) {
  return request({ url: '/ftx/account/rebate-records', method: 'get', params })
}

// 获取平台介绍
export function getPlatformIntro() {
  return request({ url: '/ftx/intro/list', method: 'get' })
}

// 获取新手引导
export function getGuideConfig() {
  return request({ url: '/ftx/guide/list', method: 'get' })
}
